import React from 'react';
import {useFormContext} from 'react-hook-form';
import {FormBlock, FormBlockFieldOther} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldOther;
}

interface Props {
  block: Block;
}

export default ({block}: Props) => {
  const blockable = block.formBlockable;
  const {formBlockFieldOtherOptions} = blockable;
  const {
    register,
    formState: {errors = {}},
  } = useFormContext();
  const error: any = errors[block.id];
  const errorMessage = error?.message;

  return (
    <div className="w-full">
      <div className="flex gap-1 mb-2 items-center">
        <label className="tracking-wide font-bold">{blockable.title}</label>
        {blockable.isRequired && <span className="text-red-500">*</span>}
      </div>
      <div className="flex flex-col gap-1">
        {formBlockFieldOtherOptions.map(
          (option) =>
            option.status === 'open' && (
              <label key={option.id} className="flex items-center">
                <input
                  type="radio"
                  value={option.id}
                  className="form-radio h-5 w-5 rounded"
                  {...register(block.id)}
                />
                <span className="ml-2">{option.label}</span>
              </label>
            ),
        )}
      </div>
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
    </div>
  );
};
